<template>
    <div>
        <h4>Available Downloads</h4>
        <b-row>
            <b-col cols="3" v-for="media in clientMedia" :key="media.id">
                <div class="p-2" style="border: 1px solid lightgrey;">
                    <p class="card-title">{{media.name}}</p>
                    <p>{{media.description}}</p>
                    <b-button variant="primary" @click="processFileDownload(media.id)">
                        Download
                    </b-button>
                </div>
            </b-col>
        </b-row>
        <DownloadModal v-if="show_modal" />
    </div>
</template>

<script>
import DownloadModal from '@/components/client/downloadModal.vue'
import _ from 'lodash';
import { licenseAppState, licenseAppMethods } from '@/state/helpers'
export default {
    data:() => ({
        show_modal: false,
    }),
    components:{
        DownloadModal,
    },
    computed:{
        ...licenseAppState,
        clientMedia(){
            let data = [];
            if(this.step_data != null){
                data = _.cloneDeep(this.step_data.media);
            }
            return data;
        }
    },
    methods:{
        ...licenseAppMethods,
        processFileDownload(id){
            let params = {
                item_id: id,
                item_type: 'media'
            }

            this.show_modal = true;
            this.$nextTick(()=>{
                this.$bvModal.show('downloadModal');
                this.$root.$once('bv::modal::hidden',(event)=>{
                    if(event.type == 'hidden' && event.componentId == 'downloadModal'){
                        this.show_modal = false;
                    }
                })
                this.getDownloadLink(params)
                .then(response => {
                    this.$eventHub.$emit('setDownloadUrl', response);
                })
            })
        },
    },
    mounted(){},
}
</script>

<style>

</style>